import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SUBSCRIBE_TEMPLATE } from "../../../actions/types";
import ContactForm from "../../help/ContactForm";
import BotRentCryptoPayment from "../subscription/BotRentCryptoPayment";
import { RentPlans, RentSubscriptions, SUB_TIER } from "../../../Const";
import RentCheckboxCard from "./RentCheckboxCard";
import { marketplaceTerms } from "../../../actions/const";
import { Trans } from "react-i18next";
import { checkSub, isPremium } from "../../../utils/SubUtils";
import useInput from "../../hooks/useInput";

const TemplateRentDetails = (props)=>{
    const {template,monthly,t}=props
    const [loading, setLoading] = useState(false);
    const [showCryptoPayment, setShowCryptoPayment] = useState(false);
    const [network, setNetwork] = useState('ERC');
    const [showContactForm, setShowContactForm] = useState(false);
    const [paymentType, bindSetPaymentType] = useInput("yearly");
    //const [performanceDuration, bindPerformanceDuration] = useInput(1);
    const [amount, setAmount] = useState(0);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const subscription =
    useSelector((state) => state.auth.user.user_subscription) || {};
    const { subPremium, subTier } = checkSub(subscription);
    const isPaid = isPremium(subscription);
    const history = useHistory();
    const dispatch = useDispatch();
    const clickUpgrade = () => {
        // dispatch({
        //     type: SUBSCRIBE_TEMPLATE,
        //     payload: template,
        //   });
        // history.push(
        //   "/bot-subscription?plan="+paymentType 
        // );
        if(isPaid && subTier != SUB_TIER.lite){
            dispatch({
                type: SUBSCRIBE_TEMPLATE,
                payload: template,
              });
            history.push(
              "/bot-subscription?plan="+paymentType 
            );
        }
        else{
            history.push(
                "/setting?loc=2"
              );
        }
    };
    
    useEffect(()=>{
        setAmount(template.yearly_fee)
        //bindSetPaymentType('yearly')
    },[template])
    // const showCryptoPaymentModal = (network,qr,address)=>{
        
    //     if (!agreeTerms || parseInt(amount) <= 0){
    //         return false
    //     }
    //     setNetwork(network)
    //     setShowCryptoPayment(true)
    //   }
    const clickPaymentType = (amount,type)=>{
        //bindSetPaymentType(type)
        setAmount(amount)
      }
    const rentPlans = (
        <>
         {Object.keys(RentSubscriptions).map((planName,key)=>(
            <RentCheckboxCard planName={planName} plan={RentSubscriptions[planName]} template={template} clickPaymentType={clickPaymentType} paymentType={paymentType} key={key} t={t}></RentCheckboxCard>
         )  
        )}
        </>
       
       
    );
    const rentOptions = (
        <>
         {Object.keys(RentSubscriptions).map((planName,key)=>(
            <option value={planName}  key={key}>US ${template[RentSubscriptions[planName]]} {t(RentPlans[planName])}</option>
         )  
        )}
        </>
       
       
    );
    return (
        <>
            <div className="col-lg-12 mt-0 mb-3 ">
            <div className="md-rent-bot mdc-trade-stock">
            <h4> <img src="/images/rent-bot.svg" alt=""/> {t("rent-this-bot")}</h4>
                               
                            <select className='mt-3 mb-3 form-control select-normal' {...bindSetPaymentType}>
                                        {rentOptions}
                            </select>
                            
                            <div className="mdcts-dropdown mt-3">
                                <input type="checkbox" id="one" value={true} onChange={(e) => setAgreeTerms(e.target.checked)}/>
                                <label for="one">{
                                    <>
                                    <span></span> <Trans i18nKey={"rent-descl"}> 
                                        <a
                                            href={marketplaceTerms}
                                            target="_blank"
                                            className="link terms-link"
                                        >
                                        </a> 
                                        </Trans> </>}
                                </label>
                            </div>	
                            <button
                                className="rent-btn"
                                onClick={() => clickUpgrade()}
                                disabled={!agreeTerms}>
                                {isPaid && subTier != SUB_TIER.lite ? t("rent-this-bot") : t("Upgrade to Premium or Pro to rent this strategy")}
                            </button>
                           
                        </div>
                  </div> 
            
            <ContactForm
                show={showContactForm}
                onHide={() => setShowContactForm(false)}
            />
        </>
    );
}
export default connect(null,{})(TemplateRentDetails)